import $ from 'jquery';
import { checkAppVersion } from './versionService';

export default class OrderService {
    constructor() {
    }

    async post(url, body, successCallback, errorCallback, timeout = 30000) {

        const versionChanged = await checkAppVersion();

        if (versionChanged) {
            console.log('Application version changed, reloading page');
            window.location.reload();
            return; 
        }

        $.ajax({
            url: url,
            type: "POST",
            contentType: "application/json",
            xhrFields: {
                withCredentials: true  
            },

            data: JSON.stringify(body),
            success: successCallback,
            error: function(jqXHR, textStatus, errorThrown) {
                if (textStatus === "timeout") {
                    console.log("Request timed out");
                }

                // Check if error is 403 (forbidden) - could be WAF blocking
                if (jqXHR.status === 403) {
                    // maybe version just changed
                    checkAppVersion().then(changed => {
                        if (changed) {
                            window.location.reload();
                        } else {
                            // Call the original error callback
                            errorCallback(jqXHR, textStatus, errorThrown);
                        }
                    }).catch(() => {
                        // If version check fails, call original error callback
                        errorCallback(jqXHR, textStatus, errorThrown);
                    });
                }
                else {
                    // Call the original error callback
                    errorCallback(jqXHR, textStatus, errorThrown);
                }
            },
        timeout: timeout
        });
    }

    getOrder(customerId, orderId, successCallback, errorCallback) {
        const body = {
            customerId: customerId,
            orderId: orderId
        };
        this.post("/api/order", body, successCallback, errorCallback);
    }

    getOrderLines(customerId, orderLineIds, startDate, endDate, country, successCallback, errorCallback) {
        const body = {
            customerId: customerId,
            orderLines: orderLineIds,
            startDate: startDate,
            endDate: endDate
        };
        this.post("/api/orderlines?region=" + country, body, successCallback, errorCallback, 600000);
    }
}